<template>
  <div>
    <div class="ls_drawer_main_content">



      <h1 class="item_detail_header" style="margin-bottom: 30px">
        {{ detail.name }}
        <Tag v-if="detail.applied" color="success">проведен</Tag>
        <Tag v-else color="warning">не проведен</Tag>
        <Tag v-show="detail.deleted_date" color="error">Удален</Tag>
      </h1>

      <Row type="flex" justify="space-between" class="fs-15 color-grey">
        <Col :xs="24" :sm="10">
          <!-- ORDER DATE -->
          <Row>
            <Col span="12">
              Дата документа:
            </Col>
            <Col span="12">
              <b>{{ formatDateTime(detail.order_date) }}</b>
            </Col>
          </Row>

          <!-- SENDER -->
          <Row v-if="detail.sender.type">
            <Col span="12">
              <!--Контрагент:-->
              <div v-if="detail.type !== TYPE_MOVING">
                <span v-show="detail.sender.type === 'supplier'"
                  >Поставщик:</span
                >
                <span v-show="detail.sender.type === 'customer'"
                  >Покупатель:</span
                >
                <span v-show="detail.sender.type === 'store'">Магазин:</span>
              </div>
              <div v-else>
                <span>Магазин (откуда):</span>
              </div>
            </Col>
            <Col span="12">
              <div v-if="detail.sender.type === 'supplier'">
                <router-link
                  v-if="display_supplier_link"
                  :to="{
                    name: 'supplier_detail',
                    params: { id: detail.sender.id }
                  }"
                  ><b>{{ detail.sender.name }}</b></router-link
                >
                <span v-else>
                  <b>{{ detail.sender.name }}</b>
                </span>
              </div>
              <div v-if="detail.sender.type === 'customer'">
                <router-link
                  v-if="display_customer_link"
                  :to="{
                    name: 'customer_detail',
                    params: { id: detail.sender.id }
                  }"
                  ><b>{{ detail.sender.name }}</b></router-link
                >
                <span v-else>
                  <b>{{ detail.sender.name }}</b>
                </span>
              </div>
              <div v-if="detail.sender.type === 'store'">
                <router-link
                  v-if="display_store_link"
                  :to="{
                    name: 'store_detail',
                    params: { id: detail.sender.id }
                  }"
                  ><b>{{ detail.sender.name }}</b></router-link
                >
                <span v-else>
                  <b>{{ detail.sender.name }}</b>
                </span>
              </div>
            </Col>
          </Row>

          <!-- RECIPIENT -->
          <Row v-if="detail.recipient.type" class="color-grey fs-15">
            <Col span="12">
              <div v-if="detail.type !== TYPE_MOVING">
                <!--Контрагент:-->
                <span v-show="detail.recipient.type === 'supplier'"
                  >Поставщик:</span
                >
                <span v-show="detail.recipient.type === 'customer'"
                  >Покупатель:</span
                >
                <span v-show="detail.recipient.type === 'store'">Магазин:</span>
              </div>
              <div v-else>
                <span>Магазин (куда):</span>
              </div>
            </Col>
            <Col span="12">
              <div v-if="detail.recipient.type === 'supplier'">
                <router-link
                  v-if="display_supplier_link"
                  :to="{
                    name: 'supplier_detail',
                    params: { id: detail.recipient.id }
                  }"
                  ><b>{{ detail.recipient.name }}</b></router-link
                >
                <span v-else>
                  <b>{{ detail.recipient.name }}</b>
                </span>
              </div>
              <div v-if="detail.recipient.type === 'customer'">
                <router-link
                  v-if="display_customer_link"
                  :to="{
                    name: 'customer_detail',
                    params: { id: detail.recipient.id }
                  }"
                  ><b>{{ detail.recipient.name }}</b></router-link
                >
                <span v-else>
                  <b>{{ detail.recipient.name }}</b>
                </span>
              </div>
              <div v-if="detail.recipient.type === 'store'">
                <router-link
                  v-if="display_store_link"
                  :to="{
                    name: 'store_detail',
                    params: { id: detail.recipient.id }
                  }"
                  ><b>{{ detail.recipient.name }}</b></router-link
                >
                <span v-else>
                  <b>{{ detail.recipient.name }}</b>
                </span>
              </div>
            </Col>
          </Row>

          <!-- DESCRIPTION -->
          <Row>
            <Col span="12">
              Комментарий:
            </Col>
            <Col span="12">
              {{ detail.description }}
            </Col>
          </Row>
        </Col>
        <Col :xs="24" :sm="10">
          <!-- DISCOUNT -->
          <Row v-if="display_total_discount">
            <Col span="12">
              Скидка:
            </Col>
            <Col span="12">
              <b>{{ detail.total_discount }} %</b>
            </Col>
          </Row>

          <!-- INVENTORY CALC SUM -->
          <Row v-if="display_inv_calc_sum">
            <Col span="12">
              Расчетная сумма:
            </Col>
            <Col span="12">
              <b
                >{{ formatNumber(detail.inventory.calc_sum) }} {{ currency }}</b
              >
            </Col>
          </Row>
          <!-- INVENTORY ACTUAL SUM -->
          <Row v-if="display_inv_actual_sum">
            <Col span="12">
              Фактическая сумма:
            </Col>
            <Col span="12">
              <b
                >{{ formatNumber(detail.inventory.actual_sum) }}
                {{ currency }}</b
              >
            </Col>
          </Row>

          <!-- SUM -->
          <Row>
            <Col span="12"> {{ total_sum_label }}: </Col>
            <Col span="12">
              <b>{{ formatNumber(detail.total_sum) }} {{ currency }}</b>
            </Col>
          </Row>

          <!-- PAID SUM -->
          <Row v-if="display_paid_sum">
            <Col span="12">
              Оплачено:
            </Col>
            <Col span="12">
              <b>{{ formatNumber(detail.paid_sum) }} {{ currency }}</b>
            </Col>
          </Row>
        </Col>
      </Row>

      <Divider dashed="true" v-if="display_money_orders"><h2>Оплата</h2></Divider>

      <Table
        class="desktop_table"
        v-if="display_money_orders"
        :columns="money_order_table.columns"
        :data="detail.money_orders"
      ></Table>

      <!-- DATA MOBILE TABLE -->
      <div class="mobile-table"  v-if="display_money_orders">

        <div v-for="item in detail.money_orders" class="card-container">
          <div>
            <h2>{{item.number}}</h2>
            <p>Счет: {{item.account_ext.name}}</p>
            <p>Контрагент: {{item.counterpart_display}}</p>
            <p>Дата: {{formatDateTime(item.order_date)}}</p>
          </div>

          <div>
            <p class="price">{{item.sum}} {{currency}}</p>
          </div>

        </div>
      </div>


      <Divider dashed="true"><h2>Товары</h2></Divider>

      <Table :columns="position_table.columns" :data="detail.positions" class="desktop_table">
        <Row slot="footer">
          <Col span="12" style="padding-left: 20px">
            <h2>Итого:</h2>
          </Col>
          <Col span="12" style="text-align: right; padding-right: 20px; font-size: 18px">
            <h2>{{ formatNumber(detail.total_sum) }} {{ currency }}</h2>
          </Col>
        </Row>
      </Table>


      <!-- DATA MOBILE TABLE -->
      <div class="mobile-table">

        <div v-for="item in detail.positions" class="card-container">
          <div>
            <h2>{{item.name}}</h2>
            <p>Штрих-код: {{item.barcode}}</p>
            <p>Артикул: {{item.sku}}</p>
            <p>Кол-во: {{item.amount}}</p>
            <p>Цена: {{formatNumber(item.base_price)}} {{currency}}</p>
            <p>Скидка: {{item.discount}} %</p>
          </div>

          <div>
            <p class="price">{{formatNumber(item.total_price)}} {{currency}}</p>
          </div>

        </div>

        <Row>
          <Col span="12" style="padding-left: 20px">
            <h2>Итого:</h2>
          </Col>
          <Col span="12" style="text-align: right; padding-right: 20px; font-size: 18px">
            <h2>{{ formatNumber(detail.total_sum) }} {{ currency }}</h2>
          </Col>
        </Row>
      </div>




    </div>
    <div class="ls_drawer_footer" style="margin-top: 20px">
      <Button style="margin-right: 8px" type="primary" @click="cancelAction()"><Icon type="md-close"/></Button>
      <Button style="margin-right: 8px" v-if="display_edit_button" type="info" @click="editAction()"
        ><Icon type="md-create" /></Button
      >
      <Button v-if="display_delete_button" type="error" @click="deleteAction()" style="float: left"
      ><Icon type="md-trash"/>
      </Button>
    </div>

    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import { base_url } from "../../http.js";
import { BaseDetailData } from "../../base/base_detail.js";
import {
  TYPE_SELL,
  TYPE_PURCHASE,
  TYPE_RETURN_SELL,
  TYPE_RETURN_PURCHASE,
  TYPE_CHANGES_IN,
  TYPE_CHANGES_OUT,
  TYPE_MOVING,
  TYPE_CHANGES_INVENTORY,
  TYPE_DEBT_SELL
} from "./const.js";

let _app = BaseDetailData();

_app.data = function() {
  return {
    DISPLAY_PAID_SUM: [
      TYPE_SELL,
      TYPE_DEBT_SELL,
      TYPE_PURCHASE,
      TYPE_RETURN_SELL,
      TYPE_RETURN_PURCHASE
    ],
    DISPLAY_TOTAL_DISCOUNT: [TYPE_SELL, TYPE_DEBT_SELL],
    DISPLAY_MONEY_ORDERS: [
      TYPE_SELL,
      TYPE_DEBT_SELL,
      TYPE_PURCHASE,
      TYPE_RETURN_SELL,
      TYPE_RETURN_PURCHASE
    ],

    DISPLAY_CALC_SUM: [TYPE_CHANGES_INVENTORY],
    DISPLAY_ACTUAL_SUM: [TYPE_CHANGES_INVENTORY],

    loading: true,
    detail: {},
    // currency: localStorage.getItem("currency"),
    position_table_static: {
      columns: [
        {
          title: "Наименование",
            // width: 220,
          key: "name",
          render: (h, params) => {
            return h(
              "router-link",
              {
                props: {
                  to: {
                    name: "catalog_detail",
                    params: { id: params.row.product }
                  }
                }
              },
              params.row.name
            );
          }
        },
        {
          title: "Штрих-код",
          key: "barcode",
          // width: 220,
          align: "center"
        },
        {
          title: "Артикул",
          key: "sku",
          // width: 120,
          align: "center"
        },
        {
          title: "Кол-во",
          key: "amount",
          // width: 90,
          align: "center"
        },
        {
          title: "Цена",
          key: "base_price",
          // width: 100,
          align: "center",
          render: (h, params) => {
            return h(
              "span",
              {},
              this.formatNumber(params.row.base_price) + " " + this.currency
            );
          }
        },
        {
          title: "Скидка",
          key: "discount",
          // width: 90,
          align: "right",
          render: (h, params) => {
            return h("span", {}, params.row.discount + " %");
          }
        },
        {
          title: "Всего",
          key: "total_price",
          // width: 130,
          align: "right",
          render: (h, params) => {
            return h(
              "span",
              {},
              this.formatNumber(params.row.total_price) + " " + this.currency
            );
          }
        }
      ],
      columns_without_discount: [
        {
          title: "Наименование",
          key: "name",
          render: (h, params) => {
            return h(
              "router-link",
              {
                props: {
                  to: {
                    name: "catalog_detail",
                    params: { id: params.row.product }
                  }
                }
              },
              params.row.name
            );
          }
        },
        {
          title: "Штрих-код",
          key: "barcode",
          // width: 220,
          align: "center"
        },
        {
          title: "Артикул",
          key: "sku",
          // width: 120,
          align: "center"
        },
        {
          title: "Кол-во",
          key: "amount",
          // width: 90,
          align: "center"
        },
        {
          title: "Цена",
          key: "base_price",
          // width: 100,
          align: "center",
          render: (h, params) => {
            return h(
              "span",
              {},
              this.formatNumber(params.row.base_price) + " " + this.currency
            );
          }
        },
        {
          title: "Всего",
          key: "total_price",
          // width: 130,
          align: "right",
          render: (h, params) => {
            return h(
              "span",
              {},
              this.formatNumber(params.row.total_price) + " " + this.currency
            );
          }
        }
      ]
    }
  };
};
_app.computed.position_table = function() {
  return (this.detail.type === TYPE_SELL || this.detail.type === TYPE_RETURN_SELL || this.detail.type === TYPE_DEBT_SELL)
    ? {columns: this.position_table_static.columns}
    : {columns: this.position_table_static.columns_without_discount};
};
_app.computed.display_paid_sum = function() {
  return this.DISPLAY_PAID_SUM.indexOf(this.detail.type) !== -1;
};
_app.computed.display_total_discount = function() {
  return this.DISPLAY_TOTAL_DISCOUNT.indexOf(this.detail.type) !== -1;
};
_app.computed.display_money_orders = function() {
  return this.DISPLAY_MONEY_ORDERS.indexOf(this.detail.type) !== -1;
};

_app.computed.display_inv_calc_sum = function() {
  return (
    this.DISPLAY_CALC_SUM.indexOf(this.detail.type) !== -1 &&
    this.detail.applied
  );
};
_app.computed.display_inv_actual_sum = function() {
  return (
    this.DISPLAY_ACTUAL_SUM.indexOf(this.detail.type) !== -1 &&
    this.detail.applied
  );
};
_app.computed.total_sum_label = function() {
  if (this.detail.type === TYPE_CHANGES_INVENTORY) return "Сумма расхождений";
  return "Сумма";
};

_app.computed.money_order_table = function() {
  let doc_number_column = {
    title: "#",
    key: "number",
    width: 60
  };
  if (this.display_money_order_link) {
    doc_number_column = {
      title: "#",
      // key: "number",
      width: 60,
      render: (h, params) => {
        return h(
          "router-link",
          {
            props: {
              to: {
                name: "money_order_detail",
                params: { id: params.row.id }
              }
            }
          },
          params.row.number
        );
      }
    };
  }

  let account_column = {
    title: "Счет",
    key: "account",
    render: (h, params) => {
      return h("span", {}, params.row.account_ext.name);
    }
    // width: 60,
  };
  if (this.display_account_link) {
    account_column = {
      title: "Счет",
      key: "account_display",
      render: (h, params) => {
        return h(
          "router-link",
          {
            props: {
              to: {
                name: "account_detail",
                params: { id: params.row.account }
              }
            }
          },
          params.row.account_ext.name
        );
      }
    };
  }

  let counterpart_column = {
    title: "Контрагент",
    key: "counterpart_display"
  };

  return {
    columns: [
      {
        title: "_",
        // key: "number",
        width: 40,
        render: (h, params) => {
          let props = {};

          if (params.row.applied === true) {
            props = {
              type: "ios-arrow-dropdown-circle",
              color: "green",
              size: 20
            };
          } else {
            props = {
              type: "ios-warning",
              color: "orange",
              size: 20
            };
          }

          return h("Icon", { props: props });
        }
      },
      doc_number_column,
      account_column,
      {
        title: "Контрагент",
        key: "counterpart_display",
        render: (h, params) => {
          let view_name = "";
          if (
            params.row.counterpart.type === "customer" &&
            this.display_customer_link
          ) {
            view_name = "customer_detail";
          } else if (
            params.row.counterpart.type === "supplier" &&
            this.display_supplier_link
          ) {
            view_name = "supplier_detail";
          } else if (
            params.row.counterpart.type === "user" &&
            this.display_user_link
          ) {
            view_name = "user_detail";
          }

          if (view_name) {
            return h(
              "router-link",
              {
                props: {
                  to: {
                    name: view_name,
                    params: { id: params.row.counterpart.id }
                  }
                }
              },
              params.row.counterpart_display
            );
          } else {
            return h("span", {}, params.row.counterpart_display);
          }
        }
      },
      {
        title: "Дата",
        // key: "order_date_display",
        render: (h, params) => {
          return h("span", {}, this.formatDateTime(params.row.order_date));
        }
      },
      {
        title: "Сумма",
        key: "sum",
        align: "right",
        render: (h, params) => {
          return h(
            "span",
            {},
            this.formatNumber(params.row.sum) + " " + this.currency
          );
        }
      }
    ]
  };
};

_app.methods.editAction = function() {
  let route_name = `${this.item_type}_edit`;
  if (this.detail.type === TYPE_CHANGES_IN) {
    route_name = "product_order_change_in_edit";
  } else if (this.detail.type === TYPE_CHANGES_OUT) {
    route_name = "product_order_change_out_edit";
  } else if (this.detail.type === TYPE_MOVING) {
    route_name = "product_order_change_moving_edit";
  } else if (this.detail.type === TYPE_CHANGES_INVENTORY) {
    route_name = "product_order_inventory_edit";
  }

  this.$router.push({
    name: route_name,
    params: { id: this.id }
  });
};

_app.methods.fetchMoneyOrders = function() {
  const path = "/money_orders/?product_order=" + this.id;
  this.$http
    .get(base_url + path)
    .then(result => {
      this.money_order_table.data = result.data.results;
    })
    .finally(() => {
      this.loading = false;
    });
};

_app.methods.fetchItem = function() {
  this.loading = true;

  const url = `${this.base_view_url}${this.id}/`;
  this.$http
    .get(url)
    .then(result => {
      this.detail = result.data;
    })
    .then(() => {
      this.position_table.columns.forEach((item, index) => {
        if (item.key === "amount" && this.detail.type === "CHANGES_INVENTORY") {
          this.position_table.columns[index].title = "Отклонение";
        }
      });
    })
    .finally(() => {
      this.loading = false;
    });
};

_app.methods.fetchPositions = function() {
  const path = "/product_order_positions/?product_order=" + this.id;
  this.$http.get(base_url + path).then(result => {
    this.position_table.data = result.data.results;
  });
};

_app.mounted = function() {
  // this.fetchMoneyOrders();
  // this.fetchPositions();
};

_app.created = function() {
  this.fetchItem();

  this.TYPE_SELL = TYPE_SELL;
  this.TYPE_PURCHASE = TYPE_PURCHASE;
  this.TYPE_RETURN_SELL = TYPE_RETURN_SELL;
  this.TYPE_RETURN_PURCHASE = TYPE_RETURN_PURCHASE;
  this.TYPE_CHANGES_IN = TYPE_CHANGES_IN;
  this.TYPE_CHANGES_OUT = TYPE_CHANGES_OUT;
  this.TYPE_MOVING = TYPE_MOVING;
};
export default _app;
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/apps/product_order/productOrderDetail.vue